import React, { useEffect, useState } from 'react';

const FloatingIconsOnScroll = () => {
  const [visible, setVisible] = useState(false);
  let timeoutId = null;

  useEffect(() => {
    const handleScroll = () => {
      setVisible(true);

      // Limpia el timeout anterior (si existe)
      if (timeoutId) clearTimeout(timeoutId);

      // Oculta los íconos después de 2 segundos sin scroll
      timeoutId = setTimeout(() => {
        setVisible(false);
      }, 2000);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      <div
        className={`music-icon left ${visible ? 'show' : 'hide'}`}
        title="¡Música!"
      >
        <i className="pi pi-music"></i>
      </div>

      <div
        className={`music-icon right ${visible ? 'show' : 'hide'}`}
        title="¡Instrumento!"
      >
        <i className="pi pi-volume-up"></i>
      </div>
    </>
  );
};

export default FloatingIconsOnScroll;